/**
 * TreeDropIndicator  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface ITreeDropIndicatorProps {
	prefixCls?: string;
	dropPosition: number;
	dropLevelOffset: number;
	indent: number;
}

// pointer-events: none; position: absolute; right: 0px; background-color: red; height: 2px; bottom: 0px; left: 0px;

export const TreeDropIndicator: React.FC<ITreeDropIndicatorProps> = ({ prefixCls }) => {
	const baseClass = BEM(prefixCls, "drop-indicator");
	return <div className={baseClass.toClassName()} />;
};
